import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.66797 9.66667C1.66797 9.29848 2.04106 9 2.5013 9H4.16797C4.62821 9 5.0013 9.29848 5.0013 9.66667C5.0013 10.0349 4.62821 10.3333 4.16797 10.3333H2.5013C2.04106 10.3333 1.66797 10.0349 1.66797 9.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.33464 9.66667C8.33464 9.29848 8.70773 9 9.16797 9H10.8346C11.2949 9 11.668 9.29848 11.668 9.66667C11.668 10.0349 11.2949 10.3333 10.8346 10.3333H9.16797C8.70773 10.3333 8.33464 10.0349 8.33464 9.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.0013 9.66667C15.0013 9.29848 15.3744 9 15.8346 9H17.5013C17.9615 9 18.3346 9.29848 18.3346 9.66667C18.3346 10.0349 17.9615 10.3333 17.5013 10.3333H15.8346C15.3744 10.3333 15.0013 10.0349 15.0013 9.66667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }